import type React from 'react';
import { PATH } from '@/router/PATH';
import { StepStrip } from './StepStrip';
import type { OnboardingStep } from './stepStripMeta';
import { useStepStripLinks } from './useStepStripLinks';

type OnboardingStepStripProps = {
    currentStep: OnboardingStep | null;
    accountingNeeded: boolean;
};

/**
 * The wizard's strip with its links back, each to `/onboarding/<step>`.
 * Rendered by the wizard's View, inside the page's `CatalogImportProvider`
 * (the strip reads the import store; `useOnboardingPage` runs outside it).
 */
export const OnboardingStepStrip: React.FC<OnboardingStepStripProps> = ({
    currentStep,
    accountingNeeded,
}) => {
    const links = useStepStripLinks({
        mode: 'wizard',
        currentStep,
        accountingNeeded,
        pathOf: PATH.ONBOARDING_STEP.BIND,
    });

    return (
        <StepStrip
            accountingNeeded={accountingNeeded}
            currentStep={currentStep}
            links={links}
            mode="wizard"
        />
    );
};
